import Globals from "@/data/globals";
import { ICampaignData } from "@/data/types";
import { traitDefinitions } from "@/db/campaign";

// TODO: Remove this?!
export default class TraitService {
  static getTraitDefinitions(): ICampaignData {
    return traitDefinitions[Globals.gameSystem];
  }
}
